import React from 'react';
import { SectionHead } from './ui';
import './partners.css';

// Brands VK Tours books and works with.
// Logos in /public/images/partners/: airline logos from the @steyng/airline-logos package,
// the rest from Wikimedia Commons. Replace any of them with the official file from the
// brand's agent/media kit when available. Without a logo, only the name is shown.
export const PARTNER_GROUPS = [
  { title: 'Airlines', items: [
    { name: 'Emirates', tall: true, logo: '/images/partners/emirates.svg' },
    { name: 'Qatar Airways', logo: '/images/partners/qatarairways.svg' },
    { name: 'Air India', logo: '/images/partners/airindia.svg' },
    { name: 'IndiGo', logo: '/images/partners/indigo.svg' },
  ] },
  { title: 'Hotels & cruises', items: [
    { name: 'Taj Hotels', tall: true, logo: '/images/partners/taj.webp' },
    { name: 'Radisson Hotels', logo: '/images/partners/radisson.webp' },
    { name: 'Cordelia Cruises', tall: true, logo: '/images/partners/cordelia.webp' },
  ] },
  { title: 'Booking platforms & rail', items: [
    { name: 'Booking.com', logo: '/images/partners/bookingdotcom.webp' },
    { name: 'Cleartrip', logo: '/images/partners/cleartrip.svg' },
    { name: 'Alhind', logo: '/images/partners/alhind.webp' },
    { name: 'Eurail', logo: '/images/partners/eurail.svg' },
  ] },
  { title: 'Tourism boards & destinations', items: [
    { name: 'Tourism Authority of Thailand', tall: true, logo: '/images/partners/tat.webp' },
    { name: 'Sentosa, Singapore', logo: '/images/partners/sentosa.webp' },
  ] },
];

const Partners = () => (
  <section className="vk-section" aria-label="We are associated with">
    <div className="vk-wrap">
      <SectionHead kicker="Our associations" title="We are associated with" />
      <ul className="vk-partners">
        {PARTNER_GROUPS.flatMap((g) => g.items).map((p) => (
          <li key={p.name}>
            {p.logo
              ? <img src={p.logo} alt={p.name} title={p.name} className={p.tall ? 'is-tall' : undefined} loading="lazy" decoding="async" />
              : <span>{p.name}</span>}
          </li>
        ))}
      </ul>
      <p className="vk-partners__note">Brand names and logos belong to their respective owners.</p>
    </div>
  </section>
);

export default Partners;
